import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useFetchUserCommissions = (queryParams = null) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const res = await instance.get("brand-ambassador-client-payments", {
			params: { ...params },
		});
		return res.data;
	};

	return useQuery(["ba-client-payments", queryParams], () => fetch(), {
		...fetchConfig,
	});
};

export default useFetchUserCommissions;
